/**
 * Returns true if the app is visible (not minimized, not in the background, etc.)
 */
export const isAppVisible = () => !window.document.hidden;
